var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#81B465"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.336 14.816H13.664A3.669 3.669 0 0 0 10 18.481v13.037a3.669 3.669 0 0 0 3.664 3.665h22.672A3.669 3.669 0 0 0 40 31.518V18.481a3.668 3.668 0 0 0-3.664-3.665Zm-1.791 2.391L25 23.357l-9.545-6.15h19.09Zm1.79 15.586h-22.67a1.275 1.275 0 0 1-1.274-1.274v-12.97l11.871 7.634c.016.01.034.017.05.026a1.372 1.372 0 0 0 .336.138l.03.007c.106.025.214.04.321.04h.003c.107 0 .215-.015.321-.04l.03-.007a1.38 1.38 0 0 0 .336-.138c.016-.01.033-.016.05-.026l11.871-7.634v12.97c0 .702-.572 1.274-1.274 1.274Z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.4145a3c26167e05a95e94f9b84157d74.svg";
export { ForwardRef as ReactComponent };